import React from 'react'
import Table from '../../../../../../common/components/table'

 
export default function WebPageCardComponent ({onSearch,onDelete,additionButtons,rowData,columnDefs,onEdit,paginationData,setPageData}: any) {
  return (
    <>

<Table columnData={columnDefs} rowData={rowData} onSearch={onSearch}enableFilter={true}
     onEdit={onEdit} onDelete={onDelete} additionButtons={additionButtons} headingName="WebPage Cards"/>
                   
   
        </>
  )
}